import type { CfdReferenceQuote } from '../constants/listedCfdReferenceQuotes';
import { getListedCfdInstrument } from '../../supabase/functions/_shared/cfdInstruments';

interface ListedCfdQuoteNoticeProps {
  quoteAvailable: boolean;
  referenceQuote: CfdReferenceQuote | null;
  symbol: string;
}

export default function ListedCfdQuoteNotice({ quoteAvailable, referenceQuote, symbol }: ListedCfdQuoteNoticeProps) {

  if (quoteAvailable) {
    if (getListedCfdInstrument(symbol)?.type === 'index') {
      return <p className="text-xs text-slate-600">Index points. 1 lot = USD 1 per point. Margin and P&amp;L: USD.</p>;
    }
    return <p className="text-xs text-slate-600">USD CFD prices. 1 lot = 1 unit of the underlying.</p>;
  }

  if (!referenceQuote) {
    return <p className="text-xs text-slate-600">Trading unavailable: waiting for a current market quote.</p>;
  }

  return (
    <p className="text-xs text-slate-600">
      Reference price: <strong>${referenceQuote.price.toFixed(2)} USD</strong>
    </p>
  );
}
